module.exports = __webpack_public_path__ + "static/media/thumbs-up.da657759.svg";